module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/company-list/company-list.component.scss
// module id = 1507
// module chunks = 0